/**
 * 참가자 입력 UI (카드형).
 * 기존 #in_names textarea와 양방향 동기화하여 기존 로직(getReady 등)과 호환.
 */
(function () {
  const LS_PARTICIPANTS = 'mbr_participants_v2';
  const LS_RECENT = 'mbr_recent_v2';
  const LS_TEMPLATES = 'mbr_templates_v2';
  const MAX_RECENT = 5;

  /** @type {{name:string, count:number}[]} */
  let participants = [];
  /** @type {boolean} */
  let advancedMode = false;

  const $ = (sel) => document.querySelector(sel);

  function init() {
    // 초기값: LS 우선, 없으면 textarea(초기 플레이스홀더) 파싱
    const saved = localStorage.getItem(LS_PARTICIPANTS);
    if (saved) {
      try {
        participants = JSON.parse(saved);
      } catch (_) {
        participants = [];
      }
    }
    if (!participants.length) {
      participants = parseTextareaToParticipants($('#in_names').value);
    }

    bindEvents();
    render();
    // 최초 로드 시 textarea에 값만 세팅(이벤트 안 쏨).
    // 기존 initialize()가 btnShuffle.click() 호출해서 처리함.
    syncToTextarea({ silent: true });
  }

  // ─── 직렬화 / 파싱 ───
  function serialize(list) {
    return list
      .filter((p) => p.name && p.name.trim())
      .map((p) => (p.count > 1 ? `${p.name}*${p.count}` : p.name))
      .join(',');
  }

  function parseTextareaToParticipants(raw) {
    const value = (raw || '').trim();
    if (!value) return [];
    const tokens = value.split(/[,\r\n]/g).map((s) => s.trim()).filter(Boolean);
    const result = [];
    for (const t of tokens) {
      const countMatch = t.match(/\*(\d+)/);
      const nameMatch = t.match(/^\s*([^\/*]+)?/);
      const name = nameMatch && nameMatch[1] ? nameMatch[1].trim() : '';
      if (!name) continue;
      const count = countMatch ? parseInt(countMatch[1], 10) : 1;
      result.push({ name, count });
    }
    return result;
  }

  // ─── 상태 변경 ───
  function saveLocal() {
    localStorage.setItem(LS_PARTICIPANTS, JSON.stringify(participants));
  }

  function syncToTextarea({ silent } = { silent: false }) {
    const ta = $('#in_names');
    const serialized = serialize(participants);
    if (ta.value !== serialized) {
      ta.value = serialized;
      if (!silent) {
        ta.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  function addParticipant(name, count = 1) {
    const trimmed = (name || '').trim();
    if (!trimmed) return;
    // 동명 존재 시 수량 증가
    const existing = participants.find((p) => p.name === trimmed);
    if (existing) {
      existing.count += count;
    } else {
      participants.push({ name: trimmed, count: Math.max(1, count) });
    }
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function removeParticipant(index) {
    participants.splice(index, 1);
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function updateCount(index, delta) {
    participants[index].count = Math.max(1, participants[index].count + delta);
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function setCount(index, value) {
    const n = parseInt(value, 10);
    if (Number.isNaN(n) || n < 1) return;
    participants[index].count = Math.min(n, 999);
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function renameParticipant(index, newName) {
    const trimmed = (newName || '').trim();
    if (!trimmed) return;
    participants[index].name = trimmed;
    saveLocal();
    syncToTextarea({ silent: false });
    updateSummary();
  }

  function clearAll() {
    if (!participants.length) return;
    if (!confirm('참가자를 모두 비울까요?')) return;
    participants = [];
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  // ─── 렌더 ───
  function render() {
    const list = $('#participantsList');
    list.innerHTML = '';
    participants.forEach((p, i) => {
      const card = document.createElement('div');
      card.className = 'participant-card';
      card.innerHTML = `
        <input type="text" class="participant-name" value="${escapeHtml(p.name)}" data-index="${i}" />
        <div class="count-stepper">
          <button class="step-btn" data-action="dec" data-index="${i}">−</button>
          <input type="number" class="count-input" value="${p.count}" min="1" max="999" data-index="${i}" />
          <button class="step-btn" data-action="inc" data-index="${i}">＋</button>
        </div>
        <button class="remove-btn" data-index="${i}" title="삭제">✕</button>
      `;
      list.appendChild(card);
    });
    updateSummary();
  }

  function updateSummary() {
    const people = participants.length;
    const marbles = participants.reduce((s, p) => s + p.count, 0);
    $('#participantsSummary').textContent = `${people}명 · ${marbles}마블`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ─── 템플릿 ───
  function loadTemplates() {
    try {
      return JSON.parse(localStorage.getItem(LS_TEMPLATES) || '[]');
    } catch (_) {
      return [];
    }
  }

  function saveTemplate(name) {
    const trimmed = (name || '').trim();
    if (!trimmed) return;
    if (!participants.length) {
      alert('저장할 참가자가 없습니다.');
      return;
    }
    const templates = loadTemplates();
    const existingIndex = templates.findIndex((t) => t.name === trimmed);
    const entry = { name: trimmed, participants: JSON.parse(JSON.stringify(participants)), savedAt: Date.now() };
    if (existingIndex >= 0) {
      if (!confirm(`"${trimmed}" 템플릿이 이미 있습니다. 덮어쓸까요?`)) return;
      templates[existingIndex] = entry;
    } else {
      templates.push(entry);
    }
    localStorage.setItem(LS_TEMPLATES, JSON.stringify(templates));
    renderTemplatesList();
  }

  function applyTemplate(name) {
    const templates = loadTemplates();
    const t = templates.find((x) => x.name === name);
    if (!t) return;
    participants = JSON.parse(JSON.stringify(t.participants));
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function deleteTemplate(name) {
    if (!confirm(`"${name}" 템플릿을 삭제할까요?`)) return;
    const templates = loadTemplates().filter((t) => t.name !== name);
    localStorage.setItem(LS_TEMPLATES, JSON.stringify(templates));
    renderTemplatesList();
  }

  function renderTemplatesList() {
    const list = $('#templatesList');
    const templates = loadTemplates();
    if (!templates.length) {
      list.innerHTML = '<div class="empty-state">저장된 템플릿이 없습니다.<br>아래에서 현재 목록을 저장해보세요.</div>';
      return;
    }
    list.innerHTML = '';
    templates.forEach((t) => {
      const row = document.createElement('div');
      row.className = 'template-row';
      const summary = `${t.participants.length}명 · ${t.participants.reduce((s, p) => s + p.count, 0)}마블`;
      row.innerHTML = `
        <div class="template-info">
          <div class="template-name">${escapeHtml(t.name)}</div>
          <div class="template-summary">${summary}</div>
        </div>
        <button class="apply-btn" data-template="${escapeHtml(t.name)}">불러오기</button>
        <button class="delete-btn" data-template-del="${escapeHtml(t.name)}">✕</button>
      `;
      list.appendChild(row);
    });
  }

  // ─── 최근 사용 ───
  function pushRecent() {
    if (!participants.length) return;
    const recents = loadRecents();
    const serialized = serialize(participants);
    const filtered = recents.filter((r) => r.serialized !== serialized);
    filtered.unshift({
      serialized,
      participants: JSON.parse(JSON.stringify(participants)),
      usedAt: Date.now(),
    });
    const trimmed = filtered.slice(0, MAX_RECENT);
    localStorage.setItem(LS_RECENT, JSON.stringify(trimmed));
  }

  function loadRecents() {
    try {
      return JSON.parse(localStorage.getItem(LS_RECENT) || '[]');
    } catch (_) {
      return [];
    }
  }

  function applyRecent(serialized) {
    const recents = loadRecents();
    const r = recents.find((x) => x.serialized === serialized);
    if (!r) return;
    participants = JSON.parse(JSON.stringify(r.participants));
    saveLocal();
    render();
    syncToTextarea({ silent: false });
  }

  function renderRecentList() {
    const list = $('#recentList');
    const recents = loadRecents();
    if (!recents.length) {
      list.innerHTML = '<div class="empty-state">최근 사용한 목록이 없습니다.</div>';
      return;
    }
    list.innerHTML = '';
    recents.forEach((r) => {
      const row = document.createElement('div');
      row.className = 'template-row';
      const summary = `${r.participants.length}명 · ${r.participants.reduce((s, p) => s + p.count, 0)}마블`;
      const names = r.participants
        .slice(0, 4)
        .map((p) => p.name)
        .join(', ');
      row.innerHTML = `
        <div class="template-info">
          <div class="template-name">${escapeHtml(names)}${r.participants.length > 4 ? ' …' : ''}</div>
          <div class="template-summary">${summary}</div>
        </div>
        <button class="apply-btn" data-recent="${escapeHtml(r.serialized)}">불러오기</button>
      `;
      list.appendChild(row);
    });
  }

  // ─── 고급 모드 ───
  function toggleAdvancedMode() {
    advancedMode = !advancedMode;
    const ta = $('#in_names');
    ta.classList.toggle('hidden-by-default', !advancedMode);
    $('#btnAdvancedMode').classList.toggle('active', advancedMode);
  }

  // ─── 이벤트 ───
  function bindEvents() {
    // 추가
    $('#btnAddParticipant').addEventListener('click', () => {
      const input = $('#newParticipantName');
      addParticipant(input.value);
      input.value = '';
      input.focus();
    });
    $('#newParticipantName').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        $('#btnAddParticipant').click();
      }
    });

    // 카드 내부 액션 (이벤트 위임)
    $('#participantsList').addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;
      const idx = Number(t.dataset.index);
      if (t.classList.contains('remove-btn')) {
        removeParticipant(idx);
      } else if (t.classList.contains('step-btn')) {
        updateCount(idx, t.dataset.action === 'inc' ? 1 : -1);
      }
    });
    $('#participantsList').addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      const idx = Number(t.dataset.index);
      if (t.classList.contains('count-input')) {
        setCount(idx, t.value);
      } else if (t.classList.contains('participant-name')) {
        renameParticipant(idx, t.value);
      }
    });

    // 빠른 액션
    $('#btnClearAll').addEventListener('click', clearAll);
    $('#btnAdvancedMode').addEventListener('click', toggleAdvancedMode);

    $('#btnTemplates').addEventListener('click', () => {
      renderTemplatesList();
      openPanel('templatesPanel');
    });
    $('#btnRecent').addEventListener('click', () => {
      renderRecentList();
      openPanel('recentPanel');
    });

    document.querySelectorAll('[data-close]').forEach((btn) => {
      btn.addEventListener('click', () => closePanel(btn.dataset.close));
    });

    $('#templatesList').addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;
      const name = t.dataset.template;
      const delName = t.dataset.templateDel;
      if (name) {
        applyTemplate(name);
        closePanel('templatesPanel');
      } else if (delName) {
        deleteTemplate(delName);
      }
    });

    $('#recentList').addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLElement)) return;
      const ser = t.dataset.recent;
      if (ser) {
        applyRecent(ser);
        closePanel('recentPanel');
      }
    });

    $('#btnSaveTemplate').addEventListener('click', () => {
      const input = $('#newTemplateName');
      saveTemplate(input.value);
      input.value = '';
    });

    // Start 시 최근 사용에 푸시
    $('#btnStart').addEventListener('click', () => pushRecent());

    // 고급 모드: textarea 직접 수정 → 카드 재생성
    $('#in_names').addEventListener('blur', () => {
      if (!advancedMode) return;
      const parsed = parseTextareaToParticipants($('#in_names').value);
      participants = parsed;
      saveLocal();
      render();
      // textarea는 이미 사용자가 값 넣었으므로 추가 write 불필요
    });
  }

  function openPanel(id) {
    document.getElementById(id).classList.remove('hidden');
  }
  function closePanel(id) {
    document.getElementById(id).classList.add('hidden');
  }

  // DOM 준비 후 init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
